import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UILink from 'UIComponents/link/UILink';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import CoreFeaturedCallout from 'ecosystem-marketplace-core/components/callouts/FeaturedCallout';
import * as ScreenSizes from 'ecosystem-marketplace-core/constants/layout/ScreenSizes';
import { useIsMaxScreenSize } from 'ecosystem-marketplace-core/hooks/useScreenSize';
import { FEATURED_CALLOUT_LAYOUT_TYPES } from 'ecosystem-marketplace-core/constants/FeaturedCallouts';
/* @ts-expect-error module is untyped */

import StorefrontUsageTrackerContext from '../../../context/StorefrontUsageTrackerContext';
import { selectCollections } from '../../../slices/collections/collectionsSlice';

function FeaturedCallout({
  callout,
  layout
}) {
  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const {
    calloutId,
    collectionId,
    externalUrl
  } = callout;
  const collections = useSelector(selectCollections);
  const collection = collections.find(c => c.id === collectionId);
  const LinkComponent = collection ? UIRouterLink : UILink;
  const link = collection ? collection.slug : externalUrl;
  if (!link) return null;
  return /*#__PURE__*/_jsx(CoreFeaturedCallout, {
    buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `marketplace-assets-ui.callouts.featuredCallout_${calloutId}.buttonText`
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `marketplace-assets-ui.callouts.featuredCallout_${calloutId}.description`
    }),
    headline: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `marketplace-assets-ui.callouts.featuredCallout_${calloutId}.headline`
    }),
    gradientColor: callout.gradientColor,
    illustrationName: callout.illustration,
    layout: layout,
    Link: LinkComponent,
    linkProps: collection ? {
      to: link
    } : {
      href: link
    },
    onClick: () => {
      trackInteraction('click featured callout', {
        section: `featured-callout::${callout.id}::static`
      });
    },
    external: !collection,
    responsive: true
  });
}

function CalloutsSection({
  callouts,
  className
}) {
  const isMobile = useIsMaxScreenSize(ScreenSizes.SM);
  if (callouts.length === 0) return null;
  const isSingleColumn = isMobile || callouts.length === 1;
  const columns = isSingleColumn ? 1 : 2;
  const layout = isSingleColumn ? FEATURED_CALLOUT_LAYOUT_TYPES.FULL_WIDTH : FEATURED_CALLOUT_LAYOUT_TYPES.MULTI;
  return /*#__PURE__*/_jsx(UICardGrid, {
    columns: columns,
    className: className,
    children: callouts.map(callout => /*#__PURE__*/_jsx(FeaturedCallout, {
      callout: callout,
      layout: layout
    }, callout.id))
  });
}

export default CalloutsSection;